import { render, staticRenderFns } from "./RedirectionsEditor.vue?vue&type=template&id=e1b87fac&"
import script from "./RedirectionsEditor.vue?vue&type=script&lang=js&"
export * from "./RedirectionsEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports